import { render, staticRenderFns } from "./areaChartFour.vue?vue&type=template&id=0a0d4f98"
import script from "./areaChartFour.vue?vue&type=script&lang=js"
export * from "./areaChartFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports